import React from "react";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import LogoFacebook from "react-ionicons/lib/LogoFacebook";
import LogoTwitter from "react-ionicons/lib/LogoTwitter";
import LogoYoutube from "react-ionicons/lib/LogoYoutube";
import LogoInstagram from "react-ionicons/lib/LogoInstagram";
import LogoLinkedin from "react-ionicons/lib/LogoLinkedin";
import vk from "routes/public/Home2/homeSources/vk_ico.png";
import wechat from "routes/public/Home2/homeSources/wechat_ico.png";

const styles = (theme) => ({
  button: {
    margin: theme.spacing(0.4),
  },
  cluster: {
    marginRight: "0.5em",
  },
});

const SocialIcons = (props) => {
  const { classes } = props;
  return (
    <div className={classes.cluster}>
      <IconButton
        className={classes.button}
        href="https://www.facebook.com/ICPCNews"
        target="_blank"
      >
        <LogoFacebook fontSize="25px" color="white" />
      </IconButton>
      <IconButton
        className={classes.button}
        href="https://twitter.com/ICPCNews"
        target="_blank"
      >
        <LogoTwitter fontSize="25px" color="white" />
      </IconButton>
      <IconButton
        className={classes.button}
        href="https://www.youtube.com/user/ICPCNews"
        target="_blank"
      >
        <LogoYoutube fontSize="25px" color="white" />
      </IconButton>
      <IconButton
        className={classes.button}
        href="https://www.instagram.com/ICPCNews/"
        target="_blank"
      >
        <LogoInstagram fontSize="25px" color="white" />
      </IconButton>
      <IconButton
        className={classes.button}
        href="https://news.icpc.global/linkedin"
        target="_blank"
      >
        <LogoLinkedin fontSize="25px" color="white" />
      </IconButton>
      <IconButton
        className={classes.button}
        href="https://vk.com/icpcnews"
        target="_blank"
      >
        <img src={vk} alt="" style={{ height: "25px", width: "25px" }} />
      </IconButton>

      <IconButton
        className={classes.button}
        href="https://www.wechat.com/en/"
        target="_blank"
      >
        <img src={wechat} alt="" style={{ height: "25px", width: "25px" }} />
      </IconButton>
    </div>
  );
};

export default withStyles(styles)(SocialIcons);
